import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

export default function WaitlistForm({ source = "website", compact = false, testIdPrefix = "waitlist", submitLabel = "Join Purposeful" }) {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            const { data } = await api.post("/waitlist", { email, name: name || undefined, source });
            toast.success(data.duplicate ? "You're already on the list. See you soon." : "Welcome to the waitlist.");
            setEmail("");
            setName("");
        } catch (err) {
            const msg = err?.response?.data?.detail;
            toast.error(typeof msg === "string" ? msg : "Could not join the waitlist. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} data-testid={`${testIdPrefix}-form`} className={compact ? "flex flex-col sm:flex-row gap-3" : "space-y-3"}>
            {!compact && (
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name (optional)"
                    data-testid={`${testIdPrefix}-name-input`}
                    className="w-full rounded-full bg-white/5 border border-white/10 px-5 py-3 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-[#D4AF37] transition"
                />
            )}
            <div className="flex flex-col sm:flex-row gap-3">
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@email.com"
                    data-testid={`${testIdPrefix}-email-input`}
                    className="flex-1 rounded-full bg-white/5 border border-white/10 px-5 py-3 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-[#D4AF37] transition"
                />
                <button
                    type="submit"
                    disabled={loading}
                    data-testid={`${testIdPrefix}-submit-button`}
                    className="btn-gold whitespace-nowrap disabled:opacity-60"
                >
                    {loading ? <Loader2 size={16} className="animate-spin" /> : <>{submitLabel} <ArrowRight size={16} /></>}
                </button>
            </div>
        </form>
    );
}
